/* Quantity tier bar and money goals for the cart drawer and cart page.
   Percentages and savings come from the cart Shopify returns; the tier table only drives the "next tier" hint. */
(function () {
  if (window.jpProgress) { window.jpProgress.renderAll(); return; }

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function parseTiers(str) {
    return (str || '').split(',').map(function (pair) {
      var p = pair.split(':');
      return { qty: parseInt(p[0], 10), pct: parseInt(p[1], 10) };
    }).filter(function (t) { return t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
  }

  function appliedPercent(cart) {
    var best = 0;
    function take(app) {
      if (app && app.value_type === 'percentage') best = Math.max(best, parseFloat(app.value) || 0);
    }
    (cart.cart_level_discount_applications || []).forEach(take);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) { take(a.discount_application); });
    });
    return Math.round(best);
  }

  function eligibleCount(cart, excludeVariantId) {
    var count = cart.item_count || 0;
    if (!excludeVariantId) return count;
    (cart.items || []).forEach(function (item) {
      if (String(item.variant_id) === String(excludeVariantId)) count -= item.quantity;
    });
    return Math.max(count, 0);
  }

  function tierState(count, tiers, appliedPct) {
    var current = null, next = null;
    tiers.forEach(function (t) {
      if (count >= t.qty) current = t;
      else if (!next) next = t;
    });
    var top = tiers[tiers.length - 1];
    return {
      count: count,
      current: current,
      next: next,
      left: next ? next.qty - count : 0,
      isMax: !!top && !next,
      fillPct: top ? Math.min(100, Math.round(count / top.qty * 100)) : 0,
      appliedPct: appliedPct,
      mismatch: !!current && appliedPct < current.pct
    };
  }

  function tierText(state, texts) {
    if (state.next) {
      return (texts.next || '').replace('[qty]', '<strong>' + state.left + '</strong>').replace('[pct]', '<strong>' + state.next.pct + '</strong>');
    }
    if (state.isMax) {
      if (!state.appliedPct) return '';
      return (texts.max || '').replace('[pct]', '<strong>' + state.appliedPct + '</strong>');
    }
    return '';
  }

  function renderTiers(el, count, applied) {
    var row = el.querySelector('[data-jp-tier-row]');
    if (!row) return;
    var d = el.dataset;
    var tiers = parseTiers(d.tiers);
    var state = tierState(count, tiers, applied);
    if (state.mismatch && window.console) console.warn('[jp-progress] tier table expects ' + state.current.pct + '% but Shopify applied ' + applied + '%');
    row.querySelector('[data-jp-tier-text]').innerHTML = tierText(state, { next: d.textNext, max: d.textMax });
    var badge = row.querySelector('[data-jp-tier-badge]');
    badge.hidden = !(applied > 0);
    badge.textContent = (d.textActive || '-[pct] %').replace('[pct]', applied);
    row.querySelector('[data-jp-tier-fill]').style.width = state.fillPct + '%';
    row.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', state.fillPct);
    row.classList.toggle('is-max', state.isMax);
    var steps = row.querySelector('[data-jp-tier-steps]');
    if (steps && tiers.length) {
      var prev = parseInt(el.dataset.prev || '-1', 10);
      var top = tiers[tiers.length - 1];
      steps.innerHTML = tiers.map(function (t) {
        var hit = count >= t.qty;
        var fresh = hit && prev >= 0 && prev < t.qty;
        return '<li class="jp-progress__mark' + (hit ? ' is-hit' : '') + (fresh ? ' is-fresh' : '') + '" style="left:' + Math.round(t.qty / top.qty * 100) + '%">' + t.qty + '+</li>';
      }).join('');
    }
    el.dataset.prev = count;
  }

  function renderGoals(el, total) {
    // ponytail: simple currency rate conversion, exact per-market thresholds need Shopify Markets shipping rates
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    el.querySelectorAll('[data-jp-goal]').forEach(function (goal) {
      var threshold = Math.round(parseFloat(goal.dataset.threshold) * 100 * rate);
      var left = Math.max(threshold - total, 0);
      var pct = threshold > 0 ? Math.min(100, Math.round(total / threshold * 100)) : 100;
      var label = goal.querySelector('[data-jp-goal-label]');
      label.innerHTML = left > 0
        ? goal.dataset.text.replace('[amount]', '<strong>' + money(left) + '</strong>')
        : '<strong>' + goal.dataset.textDone + '</strong>';
      var wasDone = goal.classList.contains('is-done');
      goal.classList.toggle('is-done', left === 0);
      if (left === 0 && !wasDone && goal.dataset.jpSeen) {
        goal.classList.remove('is-celebrate');
        void goal.offsetWidth;
        goal.classList.add('is-celebrate');
      }
      goal.dataset.jpSeen = '1';
      goal.querySelector('[data-jp-goal-fill]').style.width = pct + '%';
      goal.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', pct);
    });
  }

  function renderAll(cart) {
    document.querySelectorAll('[data-jp-progress]').forEach(function (el) {
      if (cart) {
        el.dataset.total = cart.total_price;
        el.dataset.count = eligibleCount(cart, el.dataset.exclude);
        el.dataset.applied = appliedPercent(cart);
      }
      renderTiers(el, parseInt(el.dataset.count, 10) || 0, parseInt(el.dataset.applied, 10) || 0);
      renderGoals(el, parseInt(el.dataset.total, 10) || 0);
    });
  }

  window.jpProgress = {
    parseTiers: parseTiers,
    appliedPercent: appliedPercent,
    eligibleCount: eligibleCount,
    tierState: tierState,
    tierText: tierText,
    renderAll: renderAll
  };

  document.addEventListener('jp:cart', function (e) { renderAll(e.detail.cart); });
  document.addEventListener('shopify:section:load', function () { renderAll(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { renderAll(); });
  } else {
    renderAll();
  }
})();
